import { render, staticRenderFns } from "./KullaniciLogin.vue?vue&type=template&id=00dab89f"
import script from "./KullaniciLogin.vue?vue&type=script&lang=js"
export * from "./KullaniciLogin.vue?vue&type=script&lang=js"
import style0 from "./KullaniciLogin.vue?vue&type=style&index=0&id=00dab89f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports